<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="medium"
      inline-message
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('tech_doc_orderTechDocFileType') || '工艺文档类型'"
            prop="orderTechDocFileType"
          >
            <dict-select
              v-model="formData.orderTechDocFileType"
              size="medium"
              url="/master/common/dict/biz"
              :placeholder="
                $l('form_ple_tech_doc_orderTechDocFileType') ||
                  '请选择工艺文档类型'
              "
              style="width: 100%"
              filterable
              clearable
              :body="orderTechDocFileTypeParams"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('tab_tech_doc') || '备注说明'">
            <el-input
              v-model="formData.remark"
              :placeholder="$l('form_ple_tech_doc_remark') || '请输入备注说明'"
              clearable
              maxlength="250"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item :label="$l('form_lable_file_name') || '文件名'">
          <el-input v-model="formData.fileName" readonly> </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <GoodsSpec
          :orderCode="orderCode"
          :orderTechDocCode="orderTechDocCode"
          ref="goodsSpec"
        />
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import GoodsSpec from '../goods-spec'
export default {
  mixins: [EditLoading],
  components: { GoodsSpec },
  props: {
    orderCode: String,
    orderTechDocCode: String,
  },
  data() {
    return {
      orderTechDocFileTypeParams: { dictType: 'orderTechDocFileType' },
      formData: {},
      rules: {
        orderTechDocFileType: [
          {
            required: true,
            message:
              this.$l('form_ple_tech_doc_orderTechDocFileType') ||
              '请选择工艺文档类型',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.orderTechDocCode) return
      this.$api
        .orderTechDocDetailApi({
          orderTechDocCode: this.orderTechDocCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const listOrderGoodsSpecCode = this.$refs.goodsSpec
        .getTableData()
        .map((item) => item.orderGoodsSpecCode)

      this.loadingOpen()

      const params = {
        ...this.formData,
        listOrderGoodsSpecCode,
      }

      this.$api
        .orderTechDocUpdateApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('table_Upload_failed') || '上传失败')
            return
          }
          this.$message({
            showClose: true,
            message:
              this.$l('INDEX.uploader_message_status_success') || '上传成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
